<template>
  <v-container style="max-width: 960px">
    <v-row>
      <v-col>
        <MessageBoxForJobApplication
            v-if="verifyStatusFetched"
            :email-verified="emailVerified"
            :job-name="job.name"
            :job-company="job.company.name"
            @verify="handleEmailVerify"
        />
        <CandidateResume
            :isSide="isSide"
            :candidateUser="user"
        />
      </v-col>
    </v-row>
    <v-row class="mb-12" justify="space-around">
      <v-btn
          width="250"
          large
          outlined
          :disabled="disableEditButton"
          @click="onClickEditResume"
      >
        {{label("edit")}}
      </v-btn>
      <v-btn
          class="font-weight-bold"
          width="250"
          large
          :disabled="disabledButton"
          color="primary"
          @click="onClickCandidateComplete()"
      >
        {{label("apply")}}
      </v-btn>
    </v-row>
    <ProfileRegisterDialog v-model="openDialog" @close="closeProfileRegisterDialog" />
  </v-container>
</template>

<script>
  import ComponentMixin from "../../ComponentMixin";
  import { mapGetters } from "vuex";
  import ApiMixin from "../../../ApiMixin";
  import CandidateResume from "@/components/organisms/CandidateResume"
  import ProfileRegisterDialog from "@/components/organisms/ProfileRegisterDialog";
  import MessageBoxForJobApplication from '../../molecules/MessageBoxForJobApplication'

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "JobCandidatePage",
    components: {
      MessageBoxForJobApplication,
      ProfileRegisterDialog,
      CandidateResume,
    },
    beforeMount() {
      const jobId = this.$route.params.id;
      if (jobId) {
        this.loadJob(jobId);
      }
    },
    data () {
      return {
        disabledButton: true,
        disableEditButton: false,
        openDialog: false,
      }
    },
    computed: {
      ...mapGetters("user", ["user"]),
      ...mapGetters("jobs", ["job"]),

      lang() {
        return this.$i18n.locale
      },
      isSide() {
        return !!this.job.side
      },
      jobType() {
        return this.isSide ? "side" : "main";
      },
      emailVerified() {
        return this.$auth.user.email_verified
      },
      verifyStatusFetched() {
        return !(this.emailVerified === undefined)
      }
    },
    methods: {
      onClickCandidateComplete() {
        this.disabledButton = true
        const jobId = this.$route.params.id
        const userId = this.user.id
        this.applyJob(jobId, userId, 2).then(() => {
          this.go(`/jobs/${jobId}/candidates/complete`);
        }).finally(() => {
          this.disabledButton = false
        })
        this.gtmDataLayer({
          event: "apply-5",
          jobType: this.jobType,
          isCasual: false,
        })
      },
      handleEmailVerify() {
        const userId = this.user.id
        this.sendEmailToVerify(userId)
      },
      onClickEditResume() {
        this.disableEditButton = true
        this.openDialog = true
      },
      openProfileRegisterDialog() {
        if (this.isSide) {
          if (this.user.conditionForSide !== 2) {
            this.openDialog = true
          }
        } else {
          if (this.user.conditionForJob !== 2) {
            this.openDialog = true
          }
        }
      },
      closeProfileRegisterDialog () {
        this.openDialog = false
        this.disableEditButton = false
      }
    },
    watch: {
      "$route.params.id": {
        handler: function(value) {
          this.loadJob(value);
        }
      },
      "user.id": {
        handler: function(userId) {
          if(userId) {
            this.openProfileRegisterDialog()
          }
        },
        immediate: true
      },
      emailVerified: {
        handler(newValue) {
          if (newValue) {
            this.disabledButton = false
          }
        },
        immediate: true,
      },
    }
  };
</script>
